import { Fragment } from 'react';
import { IListContentProps } from '../interfaces/interfaces';
import { TopPanelArtists } from '../panels/top-panel-artists';
import { BottomPanelArtists } from '../panels/bottom-panel-artists';
import ArtistContentImage from "./artist-content-image";
import ArtistContentMainContainer from "./artist-content-main-container";

/**
 * Product list content.
 */
const ArtistsContent = (props: IListContentProps) => {
    const artists = props.artists;

    return (
        <>
            { props.hasPanels && <TopPanelArtists width={ props.width } /> }

            {
                artists && artists.length > 0 &&
                <div className={`w-full`}>
                    <div className={`grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-x-12 gap-y-24`}>
                    {
                        artists.map((item) => {
                            return (
                                <Fragment key={ item.itemID.toString() }>
                                    <div className={'flex flex-col'}>
                                        <ArtistContentImage
                                            imageUrl={item.artistImage}
                                            imageTitle={item.artistName}
                                            link={item.link}
                                        />
                                        <ArtistContentMainContainer item={item}/>
                                    </div>
                                </Fragment>
                            )
                        })
                    }
                    </div>
                </div>
            }

            {
                (!artists || artists.length <= 0) &&
                <div className="text-center py-10">No results found...</div>
            }

            { props.hasPanels && <BottomPanelArtists/> }

        </>
    )
};

export default ArtistsContent;